import { useDeal } from '@finn/platform-modules';

import { useDealId } from '../providers/MetadataProvider';

export const useCurrentDeal = () => useDeal(useDealId());
